import * as React from 'react';
import { forwardRef } from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgPeopleSlash24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81506 12.6816C8.10522 12.6816 9.32553 13.0534 10.36 13.7041C9.36604 14.7883 8.65217 16.1438 8.34729 17.668C8.21281 18.3408 8.37878 18.9914 8.73987 19.5H1.51428C0.729789 19.4998 0.140727 18.782 0.294554 18.0127C0.914448 14.9132 3.65428 12.682 6.81506 12.6816ZM8.43518 10.9092C7.95329 11.1699 7.40142 11.3184 6.81506 11.3184C4.93265 11.318 3.40691 9.79168 3.40686 7.90918C3.40686 7.32292 3.55446 6.77089 3.81506 6.28906L8.43518 10.9092Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72016 1.71963C2.01306 1.42682 2.48784 1.42676 2.78071 1.71963L22.2807 21.2196L22.3325 21.2763C22.5726 21.5708 22.5552 22.0056 22.2807 22.2802C22.0062 22.5547 21.5714 22.5721 21.2768 22.3319L21.2202 22.2802L1.72016 2.78018C1.42726 2.48728 1.42726 2.01252 1.72016 1.71963ZM17.0258 19.4999H10.6694C9.80649 19.4998 9.15861 18.7103 9.32758 17.8642C9.63493 16.3275 10.4159 14.9849 11.4995 13.9735L17.0258 19.4999ZM16.5004 11.9999C19.9774 12.0001 22.9914 14.4546 23.6733 17.8642C23.8422 18.7101 23.1951 19.4995 22.3325 19.4999H21.975L14.6997 12.2245C15.2781 12.0777 15.8822 11.9999 16.5004 11.9999ZM16.5004 2.9999C18.5713 3.00016 20.2504 4.67899 20.2504 6.7499C20.2504 8.82076 18.5712 10.4996 16.5004 10.4999C14.4296 10.4997 12.7505 8.82081 12.7504 6.7499C12.7504 4.67895 14.4295 3.00008 16.5004 2.9999Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeopleSlash24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=PeopleSlash24.svg.js.map
